export default __webpack_public_path__ + "static/media/29t.8b93015d.jpg";